import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 22E55747-AE80-4DE9-8BC8-10B61C69F161
 * name skip-backward-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skip-backward-outline.svg
 * tags
 */
export const SkipBackwardOutlineIcon = createSvgIcon(<><path d="M18,14.17L15.83,12L18,9.83V14.17M20,19V5L13,12M4,19H6V5H4M11,14.17L8.83,12L11,9.83V14.17M13,19V5L6,12" /></>, 'SkipBackwardOutlineIcon');
export default SkipBackwardOutlineIcon